'use strict'

// babel polyfill
import '@babel/polyfill'
import 'core-js/stable'

// define
import EL from './constant/elements'

// helper
import uaDataset from './helper/uaDataset'
import sweetScrollInit from './helper/sweetScrollInit'
import ieSmoothScrollDisable from './helper/ieSmoothScrollDisable'
import getTouchSupport from './helper/getTouchSupport'
import getOrientation from './helper/getOrientation'
import getClassName from './helper/getClassName'
import addAnimationClass from './helper/addAnimationClass'
import set100vh from './helper/set100vh'
import inputAutoComplete from './helper/inputAutoComplete'

// plugins
import objectFitImages from 'object-fit-images'
import picturefill from 'picturefill'
import { throttle, debounce } from 'throttle-debounce'
import Swiper from 'swiper/bundle'

// page scripts

// require
require('intersection-observer')
require('focus-visible')
require('svgxuse')
require('./modules/JQueryModules')

/**
 * getScrollPos
 */
const getScrollPos = () => {
  const y = window.pageYOffset
  const offset = 100
  // const copyrightH = EL.COPYRIGHT.clientHeight
  // const documentH = getDocumentH()

  // add class is-scroll
  if (y > offset) {
    if (!EL.HTML.classList.contains('is-scroll')) {
      EL.HTML.classList.add('is-scroll')
    }
  } else {
    EL.HTML.classList.remove('is-scroll')
  }
}

/**
 * firstRun
 */
const firstRun = () => {
  // set ua dataset
  uaDataset()

  // set touch support dataset
  getTouchSupport()

  // getOrientation
  getOrientation()

  // ie smoothScroll disable
  ieSmoothScrollDisable(true)

  // Polyfill object-fit
  objectFitImages()

  // Polyfill picturefill
  picturefill()
}

/**
 * initRun
 */
const initRun = () => {
  // get body className
  const className = getClassName(EL.BODY)

  // add .is-loaded
  EL.HTML.classList.add('is-loaded')

  // getScrollPos
  getScrollPos()

  // setDropDown
  // setDropDown()

  // hmb menu
  // hmb()

  // inputAutoComplete
  inputAutoComplete()

  // set100vh
  set100vh()

  // navAccordion
  // navAccordion()

  // sweetScroll
  sweetScrollInit()

  // addAnimationClass
  if (EL.ANIMATIONS) {
    addAnimationClass(EL.ANIMATIONS, '-20% 0px')
  }

  if (document.getElementById('slider-room')) {
    let roomSlider
    const initRoomSlider = () => {
      const currentNum = 1
      const allNum = document.querySelectorAll('#slider-room .swiper-slide').length
      const current = document.querySelector('#slider-room .slider-room-current')
      const all = document.querySelector('#slider-room .slider-room-all')

      current.innerHTML = ('00' + currentNum).slice(-2)
      all.innerHTML = ('00' + allNum).slice(-2)

      roomSlider = new Swiper('#slider-room', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        // autoplay: {
        //   delay: 8000
        // },
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: '.slider-room-next',
          prevEl: '.slider-room-prev'
        },
        on: {
          slideChange: function () {
            const num = this.realIndex + 1
            current.innerHTML = ('00' + num).slice(-2)
          }
        }
      })
    }
    initRoomSlider()
  }

  if (document.getElementById('slider-food')) {
    let foodSlider
    const initFoodSlider = () => {
      const currentNum = 1
      const allNum = document.querySelectorAll('#slider-food .swiper-slide').length
      const current = document.querySelector('#slider-food .slider-food-current')
      const all = document.querySelector('#slider-food .slider-food-all')

      current.innerHTML = ('00' + currentNum).slice(-2)
      all.innerHTML = ('00' + allNum).slice(-2)

      foodSlider = new Swiper('#slider-food', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        // autoplay: {
        //   delay: 8000
        // },
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: '.slider-food-next',
          prevEl: '.slider-food-prev'
        },
        on: {
          slideChange: function () {
            const num = this.realIndex + 1
            current.innerHTML = ('00' + num).slice(-2)
          }
        }
      })
    }
    initFoodSlider()
  }
}

/**
 * DOMCONTENTLOADED
 */
window.addEventListener('DOMContentLoaded', firstRun)

/**
 * LOAD
 */
window.addEventListener('load', initRun)

/**
 * SCROLL
 */
window.addEventListener('scroll', throttle(100, getScrollPos), false)
